import { createSlice } from "@reduxjs/toolkit";
import { GnreState } from "./type";

const INITIAL_STATE: GnreState = {
  selectedTimestamps: null,
  paymentDate: null,
  generatedFiles: [],
  progress: 0,
  totalLotes: 0,
  lotesProcessados: 0,
  isProcessing: false,
};

const gnreSlice = createSlice({
  name: "gnre",
  initialState: INITIAL_STATE,
  reducers: {
    setSelectedTimestamps(state, action) {
      state.selectedTimestamps = action.payload;
    },
    setPaymentDate(state, action) {
      state.paymentDate = action.payload;
    },
    setGeneratedFiles(state, action) {
      const newFiles = action.payload.filter(
        (file: { fileName: string }) =>
          !state.generatedFiles.some((f) => f.fileName === file.fileName)
      );
      state.generatedFiles = [...state.generatedFiles, ...newFiles];
    },
    clearGeneratedFiles(state) {
      state.generatedFiles = [];
    },
    setProgress(state, action) {
      state.progress = action.payload;
    },
    setTotalLotes(state, action) {
      state.totalLotes = action.payload;
    },
    setIsProcessing(state, action) {
      state.isProcessing = action.payload;
    },
    setLotesProcessados(state, action) {
      state.lotesProcessados = action.payload;
    },
  },
});

export const {
  setSelectedTimestamps,
  setPaymentDate,
  setGeneratedFiles,
  clearGeneratedFiles,
  setProgress,
  setTotalLotes,
  setIsProcessing,
  setLotesProcessados,
} = gnreSlice.actions;
export default gnreSlice.reducer;
